import { useNavigate } from "react-router-dom";

import { ArrowLeft } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import LinkButtonIcon from "ds/components/ButtonIcon/LinkButtonIcon";
import useTypedContext from "hooks/useTypedContext";

import { showBreadcrumbsConfirmationModal } from "./ConfirmationModal";
import { BreadcrumbsContextData } from "./Context";
import styles from "./styles.module.css";

type BreadcrumbStepBackProps = {
  confirmation?: string;
};

const BreadcrumbStepBack = ({ confirmation }: BreadcrumbStepBackProps) => {
  const items = useTypedContext(BreadcrumbsContextData);
  const navigate = useNavigate();

  if (items.length <= 0) return null;

  const link = items?.[items.length - 2]?.link || "/";

  const handleStepBackConfirm = () => {
    showBreadcrumbsConfirmationModal({
      content: confirmation,
      onConfirm: () => navigate(link),
    });
  };

  if (confirmation) {
    return (
      <ButtonIcon
        icon={ArrowLeft}
        onPress={handleStepBackConfirm}
        className={styles.stepBack}
        variant="ghost"
      >
        Go back
      </ButtonIcon>
    );
  }

  return (
    <LinkButtonIcon icon={ArrowLeft} to={link} className={styles.stepBack} variant="ghost">
      Go back
    </LinkButtonIcon>
  );
};

export default BreadcrumbStepBack;
